export default "__VITE_ASSET__DbJ7ilRU__"